import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? "bg-slate-950/95 backdrop-blur-xl border-b border-white/5 shadow-xl" : "bg-transparent"
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/landing-page" className="flex items-center gap-2.5 group">
            <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center group-hover:scale-105 transition-transform">
              <Icon name="Zap" size={18} color="#fff" strokeWidth={2.5} />
            </div>
            <span className="text-xl font-bold font-heading">
              Fit<span className="text-teal-400">Pulse</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-6">
            {["Features", "Pricing", "Testimonials"]?.map((item) => (
              <a
                key={item}
                href={`#${item?.toLowerCase()}`}
                className="text-sm text-slate-400 hover:text-white transition-colors font-body"
              >
                {item}
              </a>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/login-page"
              className="text-sm text-slate-300 hover:text-white transition-colors font-caption px-4 py-2"
            >
              Sign In
            </Link>
            <Link
              to="/registration-page"
              className="text-sm font-semibold font-caption px-5 py-2 rounded-lg bg-primary hover:bg-primary/90 text-white transition-all duration-200 shadow-lg shadow-teal-900/30"
            >
              Start Free Trial
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden text-slate-400 hover:text-white transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <Icon name={mobileOpen ? "X" : "Menu"} size={22} />
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden border-t border-white/5 py-4 space-y-3">
            {["Features", "Pricing", "Testimonials"]?.map((item) => (
              <a
                key={item}
                href={`#${item?.toLowerCase()}`}
                className="block text-sm text-slate-400 hover:text-white transition-colors font-body py-2"
                onClick={() => setMobileOpen(false)}
              >
                {item}
              </a>
            ))}
            <div className="flex flex-col gap-2 pt-2">
              <Link to="/login-page" className="text-center text-sm text-slate-300 hover:text-white transition-colors font-caption py-2 border border-white/10 rounded-lg">
                Sign In
              </Link>
              <Link to="/registration-page" className="text-center text-sm font-semibold font-caption py-2 rounded-lg bg-primary text-white">
                Start Free Trial
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
